import { Box, Tooltip, Typography } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { DownloadToolButton } from "../../framework/Button/DownloadToolButton";
import { EllipsisTypography } from "../../framework/Typography/EllipsisTypography";
import { AttachmentIcon } from "../AttachmentIcon";
import { RemoveToolButton } from "source/components/framework/Button/RemoveToolButton";

type AttachmentListDirection = "column" | "row";

interface IAttachmentListLineProp {
    lateThreshold: number;
    attachment: IFileAttachment;
    selectedId?: string;
    isReadOnly?: boolean;
    direction: AttachmentListDirection;
    onDownload: (id: string) => void;
    onRemove?: (id: string) => void;
}

export const AttachmentListLine = ({
    attachment,
    lateThreshold,
    isReadOnly,
    direction,
    onDownload,
    onRemove
}: IAttachmentListLineProp) => {
    const timeToleranceInJsTicks = 500;
    const isLate = !Base.isNullOrUndefined(lateThreshold) && attachment.modifyDate > (lateThreshold + timeToleranceInJsTicks);
    return (
        <Box
            key={attachment.id}
            sx={(theme) => ({
                "cursor": "default",
                "display": "flex",
                "alignItems": "center",
                "justifyContent": "space-between",
                "width": direction === "column" ? "100%" : undefined,
                "maxWidth": "100%",
                "paddingLeft": ".5rem",
                "&:hover": {
                    background: theme.palette.action.hover,
                },
            })}
        >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", overflow: "hidden" }}>
                <Tooltip title={attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ", " + Base.timeToDateStr(attachment.modifyDate) + ")"}>
                    <Box display="flex" alignItems="center" overflow="hidden">
                        <AttachmentIcon fileType={attachment.type} />
                        <Box display="flex" flexWrap="nowrap" alignItems="baseline" marginLeft="4px">
                            <EllipsisTypography sx={{ maxWidth: "280px" }}>{attachment.name}</EllipsisTypography>
                            <Typography variant="caption" sx={{ marginLeft: ".5rem", color: "text.secondary", textWrap: "nowrap" }}>{Base.intToFileSizeStr(attachment.size, false)}</Typography>
                        </Box>
                        {isLate &&
                            <Typography variant="caption" sx={{ marginLeft: ".5rem", color: "text.secondary", textWrap: "nowrap" }}>{Base.timeToDateStr(attachment.modifyDate)}</Typography>
                        }
                    </Box>
                </Tooltip>
                <Box display="flex">
                    <DownloadToolButton onClick={() => onDownload(attachment.id)} />
                    {!isReadOnly && (
                        <RemoveToolButton onClick={() => onRemove(attachment.id)} />
                    )}
                </Box>
            </Box>
        </Box>
    );
};
